<form id="fileUploadForm" enctype="multipart/form-data" #fileUploadForm="ngForm"
(ngSubmit)="save()">
<div class="mb-3">
    <div class="input-group">
        <input class="form-control" type="file" id="Image" name="Image" required
        (change)="fileChangeEvent($event)">
        <div class="input-group-append">
            <button type="submit"
        class="btn btn-primary blue close-button"
        [disabled]="!fileUploadForm.form.valid">{{"Upload" | localize}}
</button>
        </div>
    </div>
    
</div>

<div class="mb-3">
    <label class="form-label">{{"FileUploaded" | localize}}</label>
    <div *ngIf="canDisplayPreview" >
        <button (click)="clearData()"><i class="fa fa-times text-danger" aria-hidden="true"></i></button> <span (click)="previewByData($event)" class="cursor-tag-a" [title]="data" target="_blank">{{data}}</span>
    </div>
    
</div>

</form>